import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/登录遍历测试报告.png'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-eb4998fa")

_pushScopeId("data-v-eb4998fa")
const _hoisted_1 = { class: "Ecard" }
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "versionGeneration versionGeneration2",
  style: {}
}, null, -1)
const _hoisted_17 = { id: "perf_report" }
const _hoisted_18 = { class: "spacName" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_20 = { class: "mainContent" }
const _hoisted_21 = { class: "spacName" }
const _hoisted_22 = { class: "gameTable" }
const _hoisted_23 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_24 = {
  colspan: 4,
  class: "game_name"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  style: {"font-weight":"bold"}
}
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 流水线: ")
const _hoisted_29 = { colspan: 2 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 安装文件: ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 开始测试: ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 测试结果: ")
const _hoisted_33 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "自动化登录遍历测试")
], -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 测试机型: ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 结束测试: ")
const _hoisted_36 = { class: "spacName" }
const _hoisted_37 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试结论")
], -1)
const _hoisted_38 = { class: "current_img" }
const _hoisted_39 = { class: "corePerformance spacName" }
const _hoisted_40 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("登录遍历用例详情")
], -1)
const _hoisted_41 = { class: "gameTable2" }
const _hoisted_42 = { style: {"color":"#808080"} }
const _hoisted_43 = { style: {"color":"#808080"} }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  style: {"height":"60px"}
}
const _hoisted_46 = { style: {"display":"flex"} }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { style: {"width":"200px","margin-bottom":"10px"} }, " 游戏日志： ", -1)
const _hoisted_48 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_49 = { style: {"display":"flex"} }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { style: {"width":"200px"} }, "测试视频：", -1)
const _hoisted_51 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_52 = { class: "gallery__big_box" }
const _hoisted_53 = {
  ref: "mask",
  class: "gallery__big_wrap"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "spacForm queryReport",
                    disabled: _ctx.loading
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "报告名称" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.report_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                            placeholder: "请选择",
                            onChange: _ctx.report_change
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smoke_lists, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: 
                      item.report_name +
                      '-[' +
                      item.create_date.replace('T', ' ') +
                      ']'
                    ,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_popconfirm, {
                            onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                            title: "确认删除该报告？",
                            placement: "top"
                          }, {
                            reference: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "mini",
                                type: "info",
                                disabled: _ctx.get_is_super
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_tooltip, {
                                    effect: "dark",
                                    content: "暂无管理员权限",
                                    placement: "top",
                                    disabled: !_ctx.get_is_super
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.sendOut,
                            class: "down_img"
                          }, {
                            default: _withId(() => [
                              _hoisted_4,
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_7,
                                    _hoisted_8,
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, [
                    _withDirectives(_createVNode("div", _hoisted_18, [
                      _hoisted_19
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("table", _hoisted_22, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_23, [
                              _createVNode("img", {
                                src: _ctx.smokeReport.project_icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_24, [
                              (!_ctx.smokeReport.test_info.language)
                                ? (_openBlock(), _createBlock("span", _hoisted_25, "【"))
                                : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(_ctx.project_info.project_name), 1),
                              (_ctx.smokeReport.test_info.language)
                                ? (_openBlock(), _createBlock("span", _hoisted_26, "[" + _toDisplayString(_ctx.smokeReport.test_info.language
                              ? _ctx.smokeReport.test_info.language
                              : "") + "]", 1))
                                : _createCommentVNode("", true),
                              (!_ctx.smokeReport.test_info.language)
                                ? (_openBlock(), _createBlock("span", _hoisted_27, "】"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_28,
                              _createVNode("span", null, [
                                _createVNode("a", {
                                  target: "_blank",
                                  href: _ctx.smokeReport.pipeline_url
                                }, _toDisplayString(_ctx.smokeReport.test_info.pipeline_name), 9, ["href"])
                              ])
                            ]),
                            _createVNode("td", _hoisted_29, [
                              _hoisted_30,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport.test_info.filename), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_31,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport.test_info.start_time), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_32,
                              _createVNode("span", null, [
                                _createVNode("b", {
                                  style: {
                              color:
                                _ctx.smoke_List[2].num === 0 ? '#00b050' : 'red',
                            }
                                }, _toDisplayString(_ctx.test_result(_ctx.smoke_List[2].num === 0)), 5)
                              ])
                            ]),
                            _hoisted_33,
                            _createVNode("td", null, [
                              _hoisted_34,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport.model_name), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_35,
                              _createVNode("span", null, _toDisplayString(_ctx.smokeReport.test_info.end_time), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createVNode(_component_el_table, {
                          "show-header": false,
                          border: "",
                          data: _ctx.smokeReport.test_info.login_channel_list
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "" }, {
                              default: _withId((scope) => [
                                _createVNode("span", _hoisted_38, [
                                  _createVNode("img", {
                                    src: scope.row.image
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("span", null, _toDisplayString(scope.row.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: ""
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 
                            'color:' +
                            (scope.row.status_desc == '成功'
                              ? '#00b050'
                              : 'red')
                          
                                }, _toDisplayString(scope.row.status_desc), 5)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row.info), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode("table", _hoisted_41, [
                          _createVNode("thead", null, [
                            _createVNode("tr", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smokeList, (item) => {
                                return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]),
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smokeReport.test_info
                          .test_case_list, (item, index) => {
                              return (_openBlock(), _createBlock("tr", { key: index }, [
                                _createVNode("td", null, _toDisplayString(index + 1), 1),
                                _createVNode("td", null, _toDisplayString(item.name), 1),
                                _createVNode("td", {
                                  style: {
                            color:
                              item.status_desc === '成功' ? '#00b050' : 'red',
                          }
                                }, _toDisplayString(item.status_desc), 5),
                                _createVNode("td", _hoisted_42, _toDisplayString(item.info), 1),
                                _createVNode("td", _hoisted_43, _toDisplayString(item.time), 1),
                                (item.image != '')
                                  ? (_openBlock(), _createBlock("td", _hoisted_44, [
                                      _createVNode("img", {
                                        onClick: ($event: any) => (_ctx.imgBtn(item.image)),
                                        style: {"max-width":"447px","max-height":"500px"},
                                        src: item.image
                                      }, null, 8, ["onClick", "src"])
                                    ]))
                                  : (_openBlock(), _createBlock("td", _hoisted_45, "该场景暂无截图"))
                              ]))
                            }), 128))
                          ])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createVNode("div", _hoisted_48, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smokeReport.log_info, (item) => {
                              return (_openBlock(), _createBlock("a", {
                                style: {"margin-right":"10px","cursor":"pointer","color":"#32c4f6"},
                                download: "",
                                key: item,
                                href: item.path
                              }, _toDisplayString(item.name), 9, ["href"]))
                            }), 128))
                          ])
                        ]),
                        _createVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createVNode("div", _hoisted_51, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.smokeReport.vedio, (item) => {
                              return (_openBlock(), _createBlock("a", {
                                style: {"margin-right":"10px","cursor":"pointer","color":"#32c4f6"},
                                download: "",
                                key: item,
                                href: item.path
                              }, _toDisplayString(item.name), 9, ["href"]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createVNode("div", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.maskBtn($event))),
                  class: "gallery__big"
                }, [
                  _createVNode("div", _hoisted_52, [
                    _createVNode("div", _hoisted_53, [
                      _createVNode("img", { src: _ctx.maskImg }, null, 8, ["src"])
                    ], 512)
                  ])
                ], 512), [
                  [_vShow, _ctx.showMask]
                ]),
                _hoisted_54
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})